import { Link, useLocation, useNavigate } from "react-router";
import { habilitadas, useInstituciones } from "@/features/instituciones";
import { FormularioInvitacion, prellenadoDe, rutaFicha } from "@/features/usuarios";
import { t } from "@/shared/i18n";
import { EncabezadoPagina, Tarjeta, CuerpoTarjeta, Vacio } from "@/shared/ui";
import { SegunConsulta, useTitulo } from "./comun";
import estilos from "./Paginas.module.css";

const i = t.invitar;

export function Invitar() {
  const instituciones = useInstituciones();
  const navegar = useNavigate();
  const ubicacion = useLocation();
  useTitulo(i.titulo);

  return (
    <div className={estilos.pila}>
      <p className={estilos.migas}>
        <Link to="/">← {t.general.volver}</Link>
      </p>
      <EncabezadoPagina titulo={i.titulo} subtitulo={i.subtitulo} />
      <SegunConsulta consulta={instituciones}>
        {() => {
          const opciones = habilitadas(instituciones.data ?? []);
          if (opciones.length === 0) {
            return (
              <Tarjeta>
                <Vacio titulo={i.sinInstitucionesTitulo} accion={<Link to="/instituciones">{i.irAInstituciones}</Link>}>
                  {i.sinInstitucionesTexto}
                </Vacio>
              </Tarjeta>
            );
          }
          return (
            <Tarjeta className={estilos.formulario}>
              <CuerpoTarjeta>
                <FormularioInvitacion
                  instituciones={opciones}
                  prellenado={prellenadoDe(ubicacion.state as unknown)}
                  alInvitar={(u) => {
                    void navegar(rutaFicha(u.usuarioId), { state: { aviso: i.listo(u.correo) } });
                  }}
                />
              </CuerpoTarjeta>
            </Tarjeta>
          );
        }}
      </SegunConsulta>
    </div>
  );
}
